// client/src/tournamentSocket.js
import { io } from 'socket.io-client';

const WS_BASE =
  process.env.REACT_APP_SOCKET_URL ||
  process.env.REACT_APP_API_URL ||
  window.location.origin;

const tournamentSocket = io(`${WS_BASE}/tournament`, {
  autoConnect: false,
  transports: ['websocket'],
  withCredentials: false,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 500,
  reconnectionDelayMax: 2000,
});

// Уже было:
tournamentSocket.on('connect_error', (err) => {
  console.warn('[tournament] connect_error:', err?.message || err);
});

// Глобальные логи — просто для отладки, на логику не влияют
tournamentSocket.on('disconnect', (reason) => {
  console.log('[tournament][GLOBAL] disconnect:', reason);
});

tournamentSocket.io?.on?.('reconnect_attempt', (n) => {
  console.log('[tournament][GLOBAL] reconnect_attempt', n);
});

tournamentSocket.io?.on?.('reconnect', () => {
  console.log('[tournament][GLOBAL] reconnect OK');
});

// 👇 ЭТО ГЛАВНОЕ — верни default-экспорт
export default tournamentSocket;
